<template>
  <div class="row">
    <slot />
    <!-- 說明會 -->
    <div class="col-12 mb-5">
      <div class="table_title_block clearfix mb-3">
        <h5 class="float-left">
          說明會
        </h5>
        <button-wrapper
          v-if="isEnrolled"
          :disabled="!canEditRecruitmentOrientations"
          class="float-right"
          color="darken_blue"
          @click="$router.push(`/campus-recruiting/${$route.params.id}/enterprise/recruitment-orientation`)"
        >
          {{ isOverDeadline ? '報名已截止' : '修改' }}
        </button-wrapper>
        <template v-else>
          <div
            v-if="!hasRecruitmentOrientations"
            class="float-right registration_status"
            :class="{
              bought: hasRecruitmentOrientations,
              'not_purchased': !hasRecruitmentOrientations
            }"
          >
            {{ hasRecruitmentOrientations | status }}報名
          </div>
        </template>
      </div>
      <table-wrapper
        v-if="hasRecruitmentOrientations"
        class="table mb-3"
      >
        <table-row
          class="d-none d-sm-flex"
          v-for="slot in currentEnterpriseCheckoutGetter.recruitmentOrientations.orientation_slots"
          :key="slot.orientation_time_slot_id"
        >
          <table-data :cols="3">
            日期
          </table-data>
          <table-data :cols="3">
            {{ slot.orientation_date }}
          </table-data>
          <table-data :cols="3">
            時間
          </table-data>
          <table-data :cols="3">
            {{ slot.duration }}
          </table-data>
        </table-row>
        <div class="d-block d-sm-none">
          <div
            v-for="slot in currentEnterpriseCheckoutGetter.recruitmentOrientations.orientation_slots"
            :key="slot.orientation_time_slot_id"
          >
            <table-row>
              <table-data :cols="5">
                日期
              </table-data>
              <table-data :cols="7">
                {{ slot.orientation_date }}
              </table-data>
            </table-row>
            <table-row style="border-bottom: solid 1.5px #00A0E9;">
              <table-data :cols="5">
                時間
              </table-data>
              <table-data :cols="7">
                {{ slot.duration }}
              </table-data>
            </table-row>
          </div>
        </div>
        <table-row>
          <table-heading
            :cols="12"
            class="text-right text-primary"
            border-top
          >
            場次單價 {{ currentOrientationInfoGetter.orientation_charge }}
            x
            報名數量 {{ currentEnterpriseCheckoutGetter.recruitmentOrientations.orientation_slots.length }}
          </table-heading>
        </table-row>
        <table-row>
          <table-heading
            :cols="12"
            class="text-right text-primary-lighten py-0"
            no-border
          >
            小計
          </table-heading>
          <table-heading
            class="text-right py-0"
            no-border
          >
            <p class="h3 text-primary-lighten">
              <small>$</small>{{ currentOrientationInfoGetter.orientation_charge * currentEnterpriseCheckoutGetter.recruitmentOrientations.orientation_slots.length }}
            </p>
          </table-heading>
        </table-row>
      </table-wrapper>
    </div>
    <!-- 博覽會 -->
    <div class="col-12 mb-5">
      <div class="table_title_block clearfix mb-3">
        <h5 class="float-left">
          博覽會
        </h5>
        <button-wrapper
          v-if="isEnrolled"
          :disabled="!canEditCareerExpo"
          class="float-right"
          color="darken_blue"
          @click="$router.push(`/campus-recruiting/${$route.params.id}/enterprise/career-expo`)"
        >
          {{ isOverDeadline ? '報名已截止' : '修改' }}
        </button-wrapper>
        <template v-else>
          <div
            v-if="!hasCareerExpo"
            class="float-right registration_status"
            :class="{
              bought: hasCareerExpo,
              'not_purchased': !hasCareerExpo
            }"
          >
            {{ hasCareerExpo | status }}報名
          </div>
        </template>
      </div>
      <table-wrapper
        v-if="hasCareerExpo"
        class="table mb-3"
      >
        <table-row>
          <table-data :cols="3">
            日期
          </table-data>
          <table-data :cols="3">
            {{ currentExpoInfoGetter.expo_start_time || new Date() | moment('YYYY/MM/DD') }}
          </table-data>
          <table-data :cols="3">
            時間
          </table-data>
          <table-data :cols="3">
            {{ currentExpoInfoGetter.expo_start_time || new Date() | moment('HH:mm') }} ~ {{ currentExpoInfoGetter.expo_end_time || new Date() | moment('HH:mm') }}
          </table-data>
        </table-row>
        <table-row>
          <table-heading
            :cols="12"
            border-top
          >
            <template v-if="isEnrolled && isAfterChoosingBoothsStartDate">
              攤位號碼
              <span
                v-for="n in currentEnterpriseCheckoutGetter.careerExpo.expo_booth_quantity"
                :key="n"
                class="badge badge-pill mr-1"
                :class="{
                  'badge-primary': n <= chosenBooths,
                  'badge-secondary': n > chosenBooths
                }"
              >{{ currentEnterpriseCheckoutGetter.careerExpo.expo_booth_numbers[n - 1] }}</span>
              <span
                v-if="chosenBooths.length < 1"
                class="ml-2"
              >
                尚未選擇攤位
              </span>
            </template>
            <span class="text-right text-primary">
              攤位單價 {{ currentExpoInfoGetter.expo_booth_charge }}
              x
              報名數量 {{ currentEnterpriseCheckoutGetter.careerExpo.expo_booth_quantity }}
            </span>
          </table-heading>
        </table-row>
        <table-row>
          <table-heading
            :cols="8"
            no-border
            class="d-flex flex-column flex-md-row flex-wrap align-items-start"
            style="gap: 16px;"
          >
            <button-wrapper
              v-if="isEnrolled && canChooseBooths"
              @click="$router.push(`/campus-recruiting/${$route.params.id}/enterprise/choose-booths`)"
            >
              選擇攤位
            </button-wrapper>
            <template>
              <button-wrapper
                v-if="isBeforeChoosingBoothsDate"
                disabled
              >
                尚未開放選位
              </button-wrapper>
            </template>
            <!-- <button-wrapper
              v-if="0"
              @click="$router.push(`/campus-recruiting/${$route.params.id}/enterprise/authorized-booths`)"
            >
              授權選位
            </button-wrapper>
            <button-wrapper
              v-if="1"
              disabled
            >
              已結束授權選位
            </button-wrapper>
            <button-wrapper
              v-if="1"
              @click="$router.push(`/campus-recruiting/${$route.params.id}/enterprise/authorized-record`)"
            >
              授權紀錄
            </button-wrapper> -->
          </table-heading>
          <table-heading
            :cols="12"
            class="text-primary-lighten py-0"
            no-border
          >
            <!-- ＊選位開放時間倒數：{{ enlistBoothTimeCountdown }} -->
          </table-heading>
          <table-heading
            :cols="12"
            class="text-right text-primary-lighten py-0"
            no-border
          >
            小計
          </table-heading>
          <table-heading
            class="text-right py-0"
            no-border
          >
            <p class="h3 text-primary-lighten">
              <small>$</small>{{ currentExpoInfoGetter.expo_booth_charge * currentEnterpriseCheckoutGetter.careerExpo.expo_booth_quantity }}
            </p>
          </table-heading>
        </table-row>
      </table-wrapper>
    </div>
    <!-- 廣告 -->
    <div class="col-12 mb-5">
      <div class="table_title_block clearfix mb-3">
        <h5 class="float-left">
          購買商品
        </h5>
        <button-wrapper
          v-if="isEnrolled"
          :disabled="!canEditPrintAdvertising"
          class="float-right"
          color="darken_blue"
          @click="$router.push(`/campus-recruiting/${$route.params.id}/enterprise/print-advertising`)"
        >
          {{ isOverDeadline ? '報名已截止' : '修改' }}
        </button-wrapper>
        <template v-else>
          <div
            v-if="!hasPrintAdvertising"
            class="float-right registration_status"
            :class="{
              bought: hasPrintAdvertising,
              'not_purchased': !hasPrintAdvertising
            }"
          >
            {{ hasPrintAdvertising | status }}購買
          </div>
        </template>
      </div>
      <table-wrapper
        v-if="hasPrintAdvertising"
        class="table mb-3"
      >
        <table-row>
          <table-heading :cols="3">
            項目
          </table-heading>
          <table-heading :cols="3">
            單價
          </table-heading>
          <table-heading :cols="3">
            數量
          </table-heading>
          <table-heading :cols="3">
            項目金額
          </table-heading>
        </table-row>
        <table-row
          v-for="ad in currentEnterpriseCheckoutGetter.printAdvertising.ads"
          :key="ad.ad_id"
        >
          <table-data :cols="3">
            {{ ad.ad_item }}
          </table-data>
          <table-data :cols="3">
            {{ ad.ad_unit_price }}
          </table-data>
          <table-data :cols="3">
            {{ ad.ad_quantity }}
          </table-data>
          <table-data :cols="3">
            {{ ad.ad_unit_price * ad.ad_quantity }}
          </table-data>
        </table-row>
        <table-row>
          <table-heading
            :cols="12"
            class="text-right text-primary-lighten"
            border-top
          >
            小計
          </table-heading>
          <table-heading
            class="text-right"
            border-top
          >
            <p class="h3 text-primary-lighten">
              <small>$</small>{{ currentEnterpriseCheckoutGetter.printAdvertising.ad_charge_total }}
            </p>
          </table-heading>
        </table-row>
      </table-wrapper>
    </div>
    <!-- 總計 -->
    <div class="col-12">
      <div class="table_title_block clearfix mb-3">
        <h5 class="float-left">
          活動費用總金額
        </h5>
      </div>
      <table-wrapper class="table mb-3">
        <table-row>
          <table-heading :cols="8">
            項目
          </table-heading>
          <table-heading :cols="4">
            金額
          </table-heading>
        </table-row>
        <table-row v-if="doesCalculateRecruitmentOrientations">
          <table-data :cols="8">
            {{ currentRecruitmentGetter.recruitment_name }}說明會
          </table-data>
          <table-data :cols="4">
            <small>$</small>{{ currentOrientationInfoGetter.orientation_charge * currentEnterpriseCheckoutGetter.recruitmentOrientations.orientation_slots.length }} 元整
          </table-data>
        </table-row>
        <table-row v-if="doesCalculateCareerExpo">
          <table-data :cols="8">
            {{ currentRecruitmentGetter.recruitment_name }}博覽會
          </table-data>
          <table-data :cols="4">
            <small>$</small>{{ currentExpoInfoGetter.expo_booth_charge * currentEnterpriseCheckoutGetter.careerExpo.expo_booth_quantity }} 元整
          </table-data>
        </table-row>
        <table-row v-if="doesCalculatePrintAdvertising">
          <table-data :cols="8">
            活動商品項目
          </table-data>
          <table-data :cols="4">
            <small>$</small>{{ currentEnterpriseCheckoutGetter.printAdvertising.ad_charge_total }} 元整
          </table-data>
        </table-row>
        <table-row>
          <table-heading
            :cols="12"
            class="text-right text-primary"
            border-top
          >
            <span>本活動共需支付</span>
            <span class="h3 text-primary-lighten">
              <small>$</small>{{ total }}
            </span>
            <span class="text-primary">
              元整
            </span>
          </table-heading>
        </table-row>
      </table-wrapper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TableWrapper from '~components/common/tables'
import TableRow from '~components/common/tables/Row'
import TableHeading from '~components/common/tables/Heading'
import TableData from '~components/common/tables/Data'
import ButtonWrapper from '~components/common/buttons'
export default {
  name: 'OrderDetails',
  components: {
    TableWrapper,
    TableRow,
    TableHeading,
    TableData,
    ButtonWrapper
  },
  filters: {
    status (value) {
      return value ? '已' : '未'
    }
  },
  props: {
    isEnrolled: Boolean
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentEnterpriseCheckoutGetter'
    ]),
    ...mapGetters('pages/campus-recruiting', [
      'currentRecruitmentGetter',
      'currentExpoInfoGetter',
      'currentOrientationInfoGetter'
    ]),
    hasRecruitmentOrientations () {
      return Object.keys(this.currentEnterpriseCheckoutGetter).includes('recruitmentOrientations')
    },
    hasCareerExpo () {
      return Object.keys(this.currentEnterpriseCheckoutGetter).includes('careerExpo')
    },
    hasPrintAdvertising () {
      return Object.keys(this.currentEnterpriseCheckoutGetter).includes('printAdvertising')
    },
    isOverDeadline () {
      return !this.$moment().isBefore(this.currentRecruitmentGetter.recruitment_enrollment_end_date)
    },
    canEditRecruitmentOrientations () {
      return this.currentRecruitmentGetter.recruitment_orientation_enabled &&
        !this.isOverDeadline
    },
    canEditCareerExpo () {
      return this.currentRecruitmentGetter.career_expo_enabled &&
        !this.isOverDeadline
    },
    canEditPrintAdvertising () {
      return this.currentRecruitmentGetter.print_advertising_enabled &&
        !this.isOverDeadline
    },
    isBeforeChoosingBoothsDate () {
      return this.$moment().isBefore(this.currentExpoInfoGetter.expo_enrollment_start_date)
    },
    isAfterChoosingBoothsStartDate () {
      return this.$moment().isAfter(this.currentExpoInfoGetter.expo_enrollment_start_date)
    },
    canChooseBooths () {
      return this.$moment().isAfter(this.currentExpoInfoGetter.expo_enrollment_start_date) &&
        this.$moment().isBefore(this.currentExpoInfoGetter.expo_enrollment_end_date)
    },
    doesCalculateRecruitmentOrientations () {
      return this.hasRecruitmentOrientations &&
        this.currentRecruitmentGetter.recruitment_orientation_enabled
    },
    doesCalculateCareerExpo () {
      return this.hasCareerExpo &&
        this.currentRecruitmentGetter.career_expo_enabled
    },
    doesCalculatePrintAdvertising () {
      return this.hasPrintAdvertising &&
        this.currentRecruitmentGetter.print_advertising_enabled
    },
    total () {
      const subTotals = []
      if (this.doesCalculateRecruitmentOrientations) {
        subTotals.push(this.currentOrientationInfoGetter.orientation_charge * this.currentEnterpriseCheckoutGetter.recruitmentOrientations.orientation_slots.length)
      }
      if (this.doesCalculateCareerExpo) {
        subTotals.push(this.currentExpoInfoGetter.expo_booth_charge * this.currentEnterpriseCheckoutGetter.careerExpo.expo_booth_quantity)
      }

      if (this.doesCalculatePrintAdvertising) {
        subTotals.push(this.currentEnterpriseCheckoutGetter.printAdvertising.ad_charge_total)
      }

      return subTotals.reduce((accumulator, currentValue) => {
        return accumulator + currentValue
      }, 0)
    },
    chosenBooths () {
      return this.currentEnterpriseCheckoutGetter.careerExpo.expo_booth_numbers.length
    }
  },
}
</script>
